import type { FormSchemaField } from '#layers/block-engine/types/form-schema';
import type { SelectFieldOption, SelectFieldOptions } from '#layers/block-engine/types/select-options';
import { BuiltinBlockIds } from 'virtual:monospace-builtin-block-ids';

type BlockProps = Record<string | symbol, any>;

export const selectOptionsFormSchema = (ctx: { options?: SelectFieldOption[]; valueInput?: { block: string; props?: BlockProps } }) => ({
	name: 'options',
	label: '$t:field_types.select.options.options.label',
	description: '$t:field_types.select.options.options.description',
	block: BuiltinBlockIds.InputRepeater,
	props: {
		schema: [
			{
				name: 'value',
				label: '$t:common.value',
				block: ctx.valueInput?.block ?? BuiltinBlockIds.Input,
				props: ctx.valueInput?.props,
			},
			{
				name: 'label',
				label: '$t:common.label',
				block: BuiltinBlockIds.Input,
			},
			{
				name: 'description',
				label: '$t:common.description',
				block: BuiltinBlockIds.Input,
			},
			{
				name: 'icon',
				label: '$t:common.icon',
				block: BuiltinBlockIds.InputIcon,
				nullable: true,
			},
			{
				name: 'color',
				label: '$t:common.color',
				block: BuiltinBlockIds.InputColor,
				nullable: true,
			},
		],
		displayBlock: {
			id: BuiltinBlockIds.DisplayLabels,
			props: {
				options: ctx.options,
			},
			valueKey: 'value',
		},
	},
} satisfies FormSchemaField<SelectFieldOptions, 'options'>);
